import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  slug: string;
  category: string;
  coverImage: string;
  rating: number;
  views: number;
  chapters: number;
  status: string;
  tags: string[];
  categoryName?: string;
}

export default function ComicCard({
  id,
  title,
  slug,
  category,
  coverImage,
  rating,
  views,
  chapters,
  status,
  tags,
  categoryName,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 no-underline"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={coverImage}
          alt={`${title} - 免费在线阅读韩漫`}
          title={`${title} - 韩漫漫画网站免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {status === 'ongoing' ? (
            <span className="px-2 py-0.5 text-xs bg-primary-500 text-background-50 rounded-full font-medium">
              连载中
            </span>
          ) : (
            <span className="px-2 py-0.5 text-xs bg-secondary-500 text-background-50 rounded-full font-medium">
              已完结
            </span>
          )}
          {categoryName && (
            <span className="px-2 py-0.5 text-xs bg-foreground-950/70 text-background-50 rounded-full">
              {categoryName}
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-3 pt-8">
          <div className="flex items-center gap-3 text-xs text-background-50/90">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {rating}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(views)}
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 mb-2">
          {title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500 mb-2">
          <span>共{chapters}话</span>
        </div>
        <div className="flex flex-wrap gap-1">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 text-xs bg-background-100 text-foreground-600 rounded"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}